
// @ts-nocheck

import { Component, Prop, Vue, Emit } from 'vue-facing-decorator';
import ChevronIcon from '../icons/ChevronIcon.vue'
import { Vue3SlideUpDown } from "vue3-slide-up-down";
import ToggleButton from './ToggleButton.vue';

@Component({
  components: {
    ToggleButton,
    ChevronIcon,
    Vue3SlideUpDown
  },
})

export default class ConsentItem extends Vue {
    expanded = false;
    collapseClass = "collapseButton collapseButtonRotatedUp"

    @Prop( { default:"" }) label!: string;
    @Prop( { default:true }) consent!: boolean;

    mounted() : void {
      // console.log( "Feature " + this.feature.id + " " +this.feature.name );

    // @ts-ignore
      // let model = window.__cmpTCModel;

      // let s = this.feature.descriptionLegal.replace("Vendors can:", "")
      // s = s.replace(/(\r\n|\n|\r)/gm, "")
      // s = s.replace("N.B. ", " ")

      // this.formattedDescriptions = s.split("* ").filter( ( e : any ) => Boolean((<String>e).length) );

      // console.log(s);

    }

    expandCollapseClick() {
      // console.log("expandCollapseClick()")
      if ( ! this.expanded )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';
      this.expanded = ! this.expanded;
    }

    @Emit('modelChangeEvent')
    changeConsent( value: any, srcEvent: any ) {
      
      // this.consent = value.value;

    }

}

